module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "boy4"
    }
  }, [_c('rect', {
    attrs: {
      "id": "boy4_bag_3",
      "fill": "#94B96B",
      "x": "5365",
      "y": "233",
      "width": "78",
      "height": "103",
      "rx": "33"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5347.775,343.8583 C5347.75867,346.179335 5346.1541,347.473323 5344.60248,350.212132 C5342.79214,353.407646 5343.00619,359.133322 5341,363.975103 C5341.5802,365.087259 5345.03931,362.989257 5345.74296,361.043899 C5346.44662,359.098541 5346.98012,357.517752 5347.22437,357.025604 C5347.46862,356.533456 5348.07716,356.567251 5348.26335,357.031941 C5348.44954,357.49663 5348.92715,374.393155 5349.30949,375.221147 C5349.69183,376.049139 5351.8073,376.078569 5352.17189,375.221147 C5352.53648,374.363725 5352.48698,360.995036 5352.66554,360.637225 C5352.8441,360.279415 5353.3091,360.451631 5353.50541,360.637225 C5353.70171,360.82282 5353.36312,375.103707 5353.67898,375.635143 C5353.99485,376.166578 5356.1796,376.074485 5356.41591,375.635143 C5356.65223,375.1958 5356.73334,360.960396 5356.9709,360.637225 C5357.20846,360.314055 5357.68981,360.350245 5357.88674,360.637225 C5358.08366,360.924206 5357.54627,374.632259 5357.88674,375.221147 C5358.2272,375.810035 5360.34547,375.819329 5360.54038,375.221147 C5360.73528,374.622965 5361.16775,360.837464 5361.37293,360.637225 C5361.57811,360.436987 5361.85412,360.455715 5362.04965,360.637225 C5362.24518,360.818736 5362.45207,371.114983 5362.79004,371.674582 C5363.12801,372.23418 5364.73116,372.366406 5364.96748,371.674582 C5365.20379,370.982758 5364.07379,345.883413 5364.10526,344.490505 C5364.21011,339.848545 5361.4373,335 5355.87413,335 C5350.31096,335 5347.81005,338.87407 5347.775,343.8583 Z",
      "id": "boy4_right_hand",
      "fill": "#AFD485",
      "transform": "translate(5353.000000, 355.500000) rotate(6.000000) translate(-5353.000000, -355.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5360.5001,286 L5360.5001,286 L5360.5001,286 C5367.39685,286 5372.98777,291.590921 5372.98777,298.487671 C5372.98777,298.665436 5372.98398,298.843181 5372.97639,299.020784 L5371.13076,342.213455 L5371.13076,342.213455 C5371.01642,344.889416 5368.81373,347 5366.13532,347 L5354.86488,347 L5354.86488,347 C5352.18648,347 5349.98378,344.889416 5349.86944,342.213455 L5348.02382,299.020784 L5348.02382,299.020784 C5347.72939,292.130321 5353.07653,286.305814 5359.96699,286.011384 C5360.14459,286.003795 5360.32234,286 5360.5001,286 Z",
      "id": "boy4_right_arm_bottom",
      "fill": "#80A259",
      "transform": "translate(5360.499996, 316.500000) rotate(6.000000) translate(-5360.499996, -316.500000) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_right_arm_top",
      "fill": "#80A259",
      "transform": "translate(5364.500000, 275.500000) rotate(6.000000) translate(-5364.500000, -275.500000) ",
      "x": "5352",
      "y": "241",
      "width": "25",
      "height": "69",
      "rx": "12.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5362.7738,482 L5385,482 L5385,506 L5337,506 C5337.40141,499.127694 5340.71991,495.127694 5346.95548,494 C5353.19106,492.872306 5358.46383,488.872306 5362.7738,482 Z",
      "id": "boy4_right_shoe_4",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5385,503 L5385,506 L5337,506 C5337.14811,504.615426 5337.30174,503.615426 5337.46087,503 C5337.94801,503 5353.79439,503 5385,503 Z",
      "id": "boy4_right_shoe_3",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_right_shoe_2",
      "fill": "#80A259",
      "points": "5362 492.863914 5360.35684 495 5354 490.632257 5356.01814 489"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_right_shoe_1",
      "fill": "#80A259",
      "points": "5367 488.6 5365.43185 491 5359 487.190483 5360.63346 485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5373.5,398 L5373.5,398 L5373.5,398 C5381.50813,398 5388,404.491871 5388,412.5 L5388,483 L5359,483 L5359,412.5 L5359,412.5 C5359,404.491871 5365.49187,398 5373.5,398 Z",
      "id": "boy4_right_leg_bottom",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_right_leg_top",
      "fill": "#94B96B",
      "x": "5359",
      "y": "326",
      "width": "29",
      "height": "96",
      "rx": "14.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5399.7738,482 L5422,482 L5422,506 L5374,506 C5374.40141,499.127694 5377.71991,495.127694 5383.95548,494 C5390.19106,492.872306 5395.46383,488.872306 5399.7738,482 Z",
      "id": "boy4_left_shoe_4",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5422,503 L5422,506 L5374,506 C5374.14811,504.615426 5374.30174,503.615426 5374.46087,503 C5374.94801,503 5390.79439,503 5422,503 Z",
      "id": "boy4_left_shoe_3",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_left_shoe_2",
      "fill": "#80A259",
      "points": "5400 492.863914 5398.35684 495 5392 490.632257 5394.01814 489"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "boy4_left_shoe_1",
      "fill": "#80A259",
      "points": "5404 488.6 5402.43185 491 5396 487.190483 5397.63346 485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5410.5,398 L5410.5,398 L5410.5,398 C5418.50813,398 5425,404.491871 5425,412.5 L5425,483 L5396,483 L5396,412.5 L5396,412.5 C5396,404.491871 5402.49187,398 5410.5,398 Z",
      "id": "boy4_left_leg_bottom",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5410.5,326 L5410.5,326 L5410.5,326 C5418.50813,326 5425,332.491871 5425,340.5 L5425,407.5 L5425,407.5 C5425,415.508129 5418.50813,422 5410.5,422 L5410.5,422 L5410.5,422 C5402.49187,422 5396,415.508129 5396,407.5 L5396,340.5 L5396,340.5 C5396,332.491871 5402.49187,326 5410.5,326 Z",
      "id": "boy4_left_leg_top",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5359,330 L5425,330 L5425,333 L5425,333 C5425,349.568542 5411.56854,363 5395,363 L5389,363 L5389,363 C5372.43146,363 5359,349.568542 5359,333 L5359,330 Z",
      "id": "boy4_hip",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5375,330 C5376.11353,330 5378.78019,330 5383,330 C5383,344.255257 5383,352.255257 5383,354 C5375.48942,348.823542 5375,343.381087 5375,330 Z",
      "id": "boy4_zipper",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5362.57998,245.833444 C5368.68853,229.557062 5410.43239,233.344233 5418.26137,245.833444 C5429.14749,263.199555 5425.707,326.646047 5424.61101,328.354485 C5414.86426,343.547737 5362.9863,338.077588 5355.79904,330.390411 C5352.72147,327.098768 5359.29841,254.57728 5362.57998,245.833444 Z",
      "id": "boy4_torso",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5406.33405,237 C5409.13978,237 5415.34259,239.925727 5415.90276,242.389372 C5415.90276,245.799129 5416.12155,302.379153 5415.90276,306 C5395.16585,298.922709 5393.09159,245.779975 5406.33405,237 Z",
      "id": "boy4_bag_2",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5362.13726,247.988262 C5363.44794,243.622097 5368.05861,238.516034 5372,238 C5366.91028,256.362731 5360.84428,280.176268 5357,297 C5357.76757,282.939265 5360.36722,253.884661 5362.13726,247.988262 Z",
      "id": "boy4_bag_1",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5410.775,345.074356 C5410.75867,347.452001 5409.1541,348.77755 5407.60248,351.58316 C5405.79214,354.856613 5406.00619,360.72194 5404,365.681813 C5404.5802,366.821095 5408.03931,364.671922 5408.74296,362.679116 C5409.44662,360.68631 5409.98012,359.066966 5410.22437,358.562814 C5410.46862,358.058662 5411.07716,358.093282 5411.26335,358.569305 C5411.44954,359.045328 5411.92715,376.353964 5412.30949,377.20215 C5412.69183,378.050337 5414.8073,378.080485 5415.17189,377.20215 C5415.53648,376.323816 5415.48698,362.629061 5415.66554,362.262524 C5415.8441,361.895986 5416.3091,362.072403 5416.50541,362.262524 C5416.70171,362.452644 5416.36312,377.081846 5416.67898,377.626244 C5416.99485,378.170641 5419.1796,378.076302 5419.41591,377.626244 C5419.65223,377.176186 5419.73334,362.593576 5419.9709,362.262524 C5420.20846,361.931471 5420.68981,361.968543 5420.88674,362.262524 C5421.08366,362.556504 5420.54627,376.598899 5420.88674,377.20215 C5421.2272,377.805402 5423.34547,377.814922 5423.54038,377.20215 C5423.73528,376.589379 5424.16775,362.467646 5424.37293,362.262524 C5424.57811,362.057401 5424.85412,362.076586 5425.04965,362.262524 C5425.24518,362.448461 5425.45207,372.995837 5425.79004,373.569084 C5426.12801,374.142331 5427.73116,374.277781 5427.96748,373.569084 C5428.20379,372.860386 5427.07379,347.148862 5427.10526,345.721981 C5427.21011,340.966803 5424.4373,336 5418.87413,336 C5413.31096,336 5410.81005,339.96856 5410.775,345.074356 Z",
      "id": "boy4_left_hand",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5419.5001,287 L5419.5001,287 L5419.5001,287 C5426.39685,287 5431.98777,292.590921 5431.98777,299.487672 C5431.98777,299.665437 5431.98398,299.843181 5431.97639,300.020784 L5430.13076,343.213455 L5430.13076,343.213455 C5430.01642,345.889416 5427.81373,348 5425.13532,348 L5413.86488,348 L5413.86488,348 C5411.18648,348 5408.98378,345.889416 5408.86944,343.213455 L5407.02382,300.020784 L5407.02382,300.020784 C5406.72939,293.130321 5412.07653,287.305815 5418.96699,287.011385 C5419.14459,287.003796 5419.32234,287 5419.5001,287 Z",
      "id": "boy4_left_arm_bottom",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_left_arm_top",
      "fill": "#80A259",
      "x": "5407",
      "y": "242",
      "width": "25",
      "height": "69",
      "rx": "12.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5380.93694,229.494992 C5381.59584,233.691388 5381.88319,236.191808 5380,238.500017 C5380.32154,239.09036 5382.48516,242.923687 5386.49086,250 C5392.88256,242.966076 5396.38561,239.132748 5397,238.500017 C5395.29459,236.135419 5395.18089,234.183751 5396.19339,229.494992 C5394.9352,226.111941 5382.69384,226.225213 5380.93694,229.494992 Z",
      "id": "boy4_neck",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5416.74529,199.512005 C5418.50038,198.492487 5421.01999,197.197331 5423.87669,199.512005 C5426.3202,201.491878 5424.48342,209.25913 5421.18723,213.56061 C5417.92228,217.821322 5412.61123,218.705928 5410.52656,217.072761 C5406.12843,226.864511 5394.91946,232.064141 5387.42845,231.999403 C5367.37344,231.826085 5359,211.776193 5359,195.121817 C5359,168.852543 5369.63017,160.000654 5387.42845,160.000654 C5403.40349,159.914807 5421.13518,168.253346 5416.74529,199.512005 Z",
      "id": "boy4_face",
      "fill": "#AFD485",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "boy4_mouth_bottom"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5378.32575,226 C5379.47905,226 5389.49181,226 5390.78027,226 C5392.06873,226 5387.44625,224 5383.29344,224 C5379.14062,224 5377.17245,226 5378.32575,226 Z",
      "fill": "#94B96B",
      "transform": "translate(5384.500000, 225.000000) scale(1, -1) translate(-5384.500000, -225.000000) "
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5377.42598,223 C5378.93415,223 5392.02775,223 5393.71266,223 C5395.39757,223 5389.35279,220 5383.92219,220 C5378.49158,220 5375.91782,223 5377.42598,223 Z",
      "id": "boy4_mouth_top",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5381.92489,199.284025 C5382.25896,197.624937 5386.13514,197.519853 5386.32606,199.284025 C5386.51699,201.048198 5387.74073,210.317304 5386.32823,211.962569 C5384.91572,213.607833 5380.76348,213.056592 5380.12089,211.962569 C5379.4783,210.868545 5381.59083,200.943114 5381.92489,199.284025 Z",
      "id": "boy4_nose",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_glasses_3",
      "stroke": "#6D8C4A",
      "stroke-width": "2",
      "fill": "#CDF1A5",
      "x": "5390",
      "y": "197",
      "width": "18",
      "height": "13",
      "rx": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5378.42308,204 L5389,204",
      "id": "boy4_glasses_2",
      "stroke": "#6D8C4A",
      "stroke-width": "3",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy4_glasses_1",
      "stroke": "#6D8C4A",
      "stroke-width": "2",
      "fill": "#CDF1A5",
      "x": "5360",
      "y": "197",
      "width": "18",
      "height": "13",
      "rx": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5376.97094,192.573047 C5376.52062,190.535821 5362.3042,190.503758 5362.01891,192.323628 C5361.73362,194.143499 5364.71101,193.275769 5368.6296,193.623966 C5372.54819,193.972164 5377.42125,194.610274 5376.97094,192.573047 Z",
      "id": "boy4_right_brow",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5390.02906,192.573047 C5390.47938,190.535821 5404.6958,190.503758 5404.98109,192.323628 C5405.26638,194.143499 5402.28899,193.275769 5398.3704,193.623966 C5394.45181,193.972164 5389.57875,194.610274 5390.02906,192.573047 Z",
      "id": "boy4_left_brow",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5373.05247,174.736172 C5374.19585,182.828614 5380.8664,192.797309 5383.2541,195.163871 C5383.79026,193.615208 5383.74646,188.267829 5383.2541,186.419773 C5384.71018,188.008968 5388.66297,193.576242 5389.88023,195.991756 C5390.5246,193.015246 5390.94545,188.726416 5390.5246,186.419773 C5392.67208,188.726416 5396.23102,193.273128 5397.63118,195.991756 C5398.73984,193.273128 5399.90584,190.187943 5399.90584,188.726416 C5401.65886,190.436231 5406.96397,197.298985 5408.73516,199.441931 C5409.26366,196.837656 5409.26366,195.163871 5409.26366,193.273128 C5410.5431,194.748753 5413.04385,199.454855 5414.18117,202.20912 C5415.21555,200.465235 5415.94046,198.086142 5415.94046,194.552552 C5417.36,197.223011 5417.71085,200.979824 5418.22763,204 C5419.47114,202.317599 5420.13993,200.082622 5420.68942,198.726833 C5421.49649,199.837859 5423.17159,202.037199 5424.61415,203.614646 C5425.7761,197.098084 5425.50116,188.726416 5423.17159,184.25607 C5425.50116,185.554292 5428.06448,186.419773 5430,186.419773 C5423.151,178.874816 5424.9868,173.589508 5415.85991,167.778646 C5418.77045,168.071186 5422.8163,169.004809 5425.50116,168.712269 C5421.94706,165.608678 5412.21578,161.576555 5408.73516,160.508606 C5405.25455,159.440658 5398.24486,156.548933 5389.88023,157.059998 C5381.51561,157.571062 5377.88359,160.007332 5375.56695,162.760423 C5371.29177,161.631382 5366.93949,159.701869 5364.7052,158.586926 C5364.97207,160.101713 5366.34559,162.760423 5367.85355,164.657432 C5361.32108,166.622191 5360.33919,175.559358 5352,181.632214 C5353.60041,182.10725 5356.26468,181.817451 5358.38954,181.128199 C5357.05035,183.157967 5353.38159,188.726416 5354.03039,192.632829 C5355.2408,190.964135 5357.27927,188.726416 5358.38954,188.267829 C5357.93009,190.661021 5357.37293,194.167197 5359.09891,197.418821 C5360.97265,191.054991 5365.90753,179.425826 5373.05247,174.736172 Z",
      "id": "boy4_hair",
      "fill": "#80A259"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-541f7e24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/background/boy4.vue
// module id = 712
// module chunks = 1